function mockBnpProposal(price) {
  return {
    proposalId: Number(10101),
    lenderReference: 'BNP_REF',
    isPrime: true,
    isPreferredAcceptance: true,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: 8,
    maxVehicleAgeAtEnd: 12,
    minMileage: null,
    maxMileage: Number(100000),
    maxLendAmount: Number(75000),
    minLendAmount: Number(3000),
    minTerm: Number(24),
    maxTerm: Number(60),
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(price),
    apr: null,
    flatRate: null,
    financeCompany: "BNP Paribas",
    financeCompanyId: 63,

    rank: null,
  };
}

module.exports = {
  mockBnpProposal
};
